import MuiFab from '@material-ui/core/Fab'
import React from 'react'
import { withStyles } from '@material-ui/core/styles'

const Fab = withStyles(theme => {
  return {
    extended: {
      fontWeight: 'bold',
      '& svg': {
        marginRight: theme.spacing.unit,
      },
    },
  }
})(MuiFab)

export default props => {
  return <Fab {...props} />
}
